import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Card, F0Icon } from '@factorialco/f0-react'
import { Calendar, Clock } from '@factorialco/f0-react/icons/app'
import { AtsJobPostingPremiumPortalsQuery } from 'generated/resources/graphql'

type IntegrationsJoinBoard = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<AtsJobPostingPremiumPortalsQuery['integrationsJoin']>['premiumBundlesConnection']
        >['nodes']
      >[0]
    >['products']
  >[0]
>['jobBoard']

import i18n from 'modules/core/lib/i18n'

interface Props {
  offerName: string
  durationDays: number
  jobBoard: IntegrationsJoinBoard
}

export const CheckoutProductDetail = ({ offerName, durationDays, jobBoard }: Props) => {
  return (
    <F0Card
      avatar={{
        type: 'company',
        name: jobBoard.name,
        src: jobBoard.logoUrl,
      }}
      title={jobBoard.name}
      compact
      description={offerName}
    >
      <Box flexDirection="row" gap="s12" alignItems="center">
        <Box flexDirection="row" gap="s4" alignItems="center">
          <F0Icon icon={Clock} />
          <Text.Normal size="200" color="grey1000">
            {i18n.t('ats.job_details.marketplace.purchase_modal.publish_timing_warn', {
              hours: jobBoard.hoursToProcess,
            })}
          </Text.Normal>
        </Box>
        <Box flexDirection="row" gap="s4" alignItems="center">
          <F0Icon icon={Calendar} />
          <Text.Normal size="200" color="grey1000">
            {i18n.t('ats.job_details.marketplace.purchase_modal.duration_warn', {
              days: durationDays,
            })}
          </Text.Normal>
        </Box>
      </Box>
    </F0Card>
  )
}
